import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createTheme, MantineProvider } from "@mantine/core";
import { theme } from "./services/theme/theme";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import { DatesProvider } from "@mantine/dates";
import { App } from "./App";
import { Notifications } from "@mantine/notifications";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MantineProvider theme={createTheme(theme)}>
      <DatesProvider settings={{ locale: "hr" }}>
        <Notifications />
        <App />
      </DatesProvider>
    </MantineProvider>
  </React.StrictMode>
);
